import React, { useState, useContext } from 'react';

import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';

import ErrorHandler from '../../../../../libs/errors/errors';
import ConfirmModal from '../../../../common/ConfirmModal';
import { PagePropType } from '../../../pages/types/page';
import { NavigationContext } from '../../context/Navigation.context';

import './DeletePageModal.scss';

const propTypes = {
  page: PagePropType,
  disabled: PropTypes.bool,
  onDelete: PropTypes.func,
};
const defaultProps = {
  page: null,
  disabled: false,
  onDelete: () => null,
};

export default function DeletePageModal({ page, disabled: disabledProp, onDelete: onDeleteProp }) {
  const { navigation } = useContext(NavigationContext);
  const { deletePage } = navigation;

  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { title } = page || {};

  function openDeleteModal() {
    setShowDeleteModal(true);
  }

  function closeDeleteModal() {
    setShowDeleteModal(false);
  }

  async function onDelete() {
    try {
      setLoading(true);

      await deletePage(page);

      await onDeleteProp();
      closeDeleteModal();
    } catch (e) {
      ErrorHandler.capture(e);
    } finally {
      setLoading(false);
    }
  }

  const disableDeleteButton = loading || disabledProp;

  return (
    <ConfirmModal
      trigger={
        <Button
          content="DELETE"
          className="delete-red delete"
          onClick={openDeleteModal}
          disabled={disableDeleteButton}
        />
      }
      header="Delete Link"
      content={
        <Modal.Content>
          Are you sure you want to remove the link <b>{title}</b> ?
        </Modal.Content>
      }
      open={showDeleteModal}
      onCancel={closeDeleteModal}
      onConfirm={onDelete}
      className="delete-style-rule-confirm-modal"
      confirmButton={<Button className="delete-red" primary={false} content="YES" />}
      cancelButton={<Button className="action-button" primary={false} content="NO" />}
    />
  );
}

DeletePageModal.propTypes = propTypes;
DeletePageModal.defaultProps = defaultProps;
